<template>
  <router-view />
</template>

<script>
export default {
  name: "app-company"
};
</script>

<style lang="scss" scoped></style>
